module.exports = __webpack_public_path__ + "static/media/mujer-hombre5.53d8eb99.jpg";